/* 
Notes:
30112022 (Hams) Created
*/

import { useEffect, useState } from 'react';
import { Console, envInstanceName } from './../../services/platform-api';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { useAxios } from '../../hooks/useAxios';
import { GetUserEmail } from '../../services/get-user-email';
import WFSettings from '../../data/platform/workflow_settings.json';

export const WorkatoConnectinoData = (combination_id, is_basic) => {
  const [workatoId] = useSessionStorage('workatoId', '');
  const [cons_data, setConnectionsData] = useState([]);
  const [isCheckingConns, setIsCheckingConns] = useState(true);
  const [conns_connected, setAllConnected] = useState(false);

  const { fetchNow } = useAxios();
  const [isGettingRecipe, setIsGettingRecipe] = useState(true);
  const [workato_recipe, setRecipe] = useState(null);
  const [allRecipesData, setAllRecipeData] = useState(null);
  const [isStarterRecipe, setIsStarterRecipe] = useState(false);

  const [workato_id] = useSessionStorage('workatoId', '');

  const email = GetUserEmail();
  let ourcons_connected = false;
  let finished_fetching_recipe = false;
  let recipe_to_start_id;
  let basic_recipe_to_start_id;
  let basic_recipe;
  let needs_starter = true;
  let actual_recipe_id;

  useEffect(() => {
    const do_looper = () => {
      if (isCheckingConns && !is_basic) {
        const headers = {
          'Content-type': 'application/json',
          'x-user-email': 'integrations@arcanum.ai',
          'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
        };

        let cons_filtered = [];

        fetch(`/api/platform/proxy?url=api/managed_users/${workatoId}/connections/`, {
          method: 'GET',
          headers: headers,
        })
          .then((response) => response.json())
          .then((connectionRes) => {
            Console('connectionRes: ', connectionRes, 'log');

            if (connectionRes?.result) {
              Console('connectionRes.result: ', connectionRes?.result, 'log');

              // check if the provider is Xero
              if (WFSettings.connectors_comboIDs.xero.includes(combination_id)) {
                cons_filtered = connectionRes?.result.filter((connection) => connection.provider === 'xero');
              }

              if (WFSettings.connectors_comboIDs.gmail.includes(combination_id)) {
                // Gmail
                const gmail_filtered = connectionRes?.result.filter((connection) => connection.provider === 'gmail');
                cons_filtered = [...cons_filtered, ...gmail_filtered];
                Console('gmail_filtered.result: ', cons_filtered, 'log');
              }
              if (WFSettings.connectors_comboIDs.google_drive.includes(combination_id)) {
                // G drive
                const g_drive_filtered = connectionRes?.result.filter(
                  (connection) => connection.provider === 'google_drive',
                );
                cons_filtered = [...cons_filtered, ...g_drive_filtered];
              }
              if (WFSettings.connectors_comboIDs.google_sheets.includes(combination_id)) {
                // G sheets
                const g_sheets_filtered = connectionRes?.result.filter(
                  (connection) => connection.provider === 'google_sheets',
                );
                cons_filtered = [...cons_filtered, ...g_sheets_filtered];
              }
              if (WFSettings.connectors_comboIDs.outlook.includes(combination_id)) {
                // Outlook
                let outlook_filtered;

                if (combination_id === 168) {
                  // Check for Arcos Assistant specific connector
                  outlook_filtered = connectionRes?.result.filter((connection) => connection.name.includes('Arcos'));
                } else {
                  // Normal Outlook connector for all recipes.
                  outlook_filtered = connectionRes?.result.filter(
                    (connection) => connection.provider === 'outlook' && !connection.name.includes('Arcos'),
                  );
                }
                cons_filtered = [...cons_filtered, ...outlook_filtered];
              }

              setConnectionsData(cons_filtered);
            }

            let temp_conn_test = true;
            Console('cons filtered: ', cons_filtered, 'log');
            if (Array.isArray(cons_filtered) && cons_filtered.length > 0) {
              cons_filtered.forEach((element) => {
                Console('element. ', element, 'log');
                if (element.authorization_status !== 'success') {
                  temp_conn_test = false;
                }
              });
              Console('temp conn test...: ', temp_conn_test, 'log');
              if (temp_conn_test) {
                Console('conns finally set... move on. ', '', 'log');
                //  clearInterval(intervalId);
                setIsCheckingConns(false);
                ourcons_connected = true;
                setAllConnected(true);
              } else {
                setAllConnected(false);
                ourcons_connected = false;
              }
            } else {
              setAllConnected(false);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        // faking the conns are done for the basic
        Console('skipping conss  ', '', 'log');
        setAllConnected(true);
        ourcons_connected = true;
      }

      //// recipe setups
      if (isGettingRecipe) {
        Console('recipe loop get data  ', '', 'log');

        // get current token from local storage
        let authObj = window.localStorage.getItem('auth');
        authObj = JSON.parse(authObj);
        let token = authObj.token;
        const headers2 = {
          Authorization: 'Bearer ' + token,
        };
        fetch(`/api/platform/userByWorkatoRecipe/${workato_id}/`, {
          method: 'GET',
          headers: headers2,
        })
          .then((response) => response.json())
          .then((recipeRes) => {
            Console('our recipedata ', recipeRes, 'log');
            if (recipeRes?.workato_recipes) {
              Console('our data?.workato_recipes ', recipeRes?.workato_recipes, 'log');
              Console('our combination_id we are looking for:  ', combination_id, 'log');

              // look for our recipe
              const recipe_array = recipeRes?.workato_recipes;
              let filterRecipe = recipe_array.filter((recipe) => recipe?.combination === combination_id);
              Console('our filterRecipe in loop:  ', filterRecipe[0], 'log');
              actual_recipe_id = filterRecipe[0]?.recipe_id;

              if (is_basic) {
                // Basic is set in Workato recipe name
                basic_recipe = recipe_array.filter(
                  (recipe) => recipe?.combination === combination_id && recipe.name.indexOf(' Basic') !== -1,
                );

                Console('is basic:  basic_recipe', basic_recipe, 'log');
                basic_recipe_to_start_id = basic_recipe[0]?.recipe_id;
                Console('is basic:  basic_recipe_to_start_id', basic_recipe_to_start_id, 'log');
              }
              setRecipe(filterRecipe[0]);
              setAllRecipeData(recipeRes);
              if (filterRecipe[0]?.status === 'complete' && filterRecipe[0]?.combination !== 0) {
                Console('done, clean up:  ', '', 'log');
                setIsGettingRecipe(false);
                finished_fetching_recipe = true;
              }
              if (filterRecipe[0]?.status !== 'no started') {
                needs_starter = false;
              }

              //
              //
              // find if this recipe needs to use a webhook to start

              Console('debug 2', '', 'log');
              if (recipeRes && ourcons_connected) {
                Console('debug 3', '', 'log');
                let starter_recipe;
                const google_starter_combinations = [1, 2, 3, 4, 7];

                if (google_starter_combinations.includes(combination_id)) {
                  starter_recipe = recipeRes?.workato_recipes.filter((recipe) => recipe.combination === 0);
                  Console('starter_recipe', starter_recipe, 'log');
                  if (starter_recipe?.[0].status === 'started') {
                    Console('started so skip for now and wait', '', 'log');
                  }
                }

                Console('filterRecipe[0]?.status', filterRecipe[0]?.status, 'log');
                Console('filterRecipe[0]?.workato_webhook', filterRecipe[0]?.workato_webhook, 'log');
                if (
                  (starter_recipe?.length &&
                    starter_recipe?.[0]?.status !== 'started' &&
                    starter_recipe?.[0]?.status !== 'complete') ||
                  (basic_recipe_to_start_id &&
                    basic_recipe[0].status !== 'started' &&
                    basic_recipe[0].status !== 'complete') ||
                  filterRecipe[0]?.status === 'ready' ||
                  filterRecipe[0]?.status === 'no started' ||
                  filterRecipe[0]?.workato_webhook !== null
                ) {
                  Console('basic_recipe_to_start_id', basic_recipe_to_start_id, 'log');
                  setIsStarterRecipe(true);
                  setIsCheckingConns(true);
                  if (basic_recipe_to_start_id !== null && is_basic) {
                    // basic upload, start it for the user
                    recipe_to_start_id = basic_recipe_to_start_id;
                  } else if (filterRecipe[0]?.status === 'ready') {
                    // this is our primary workflow recipe e.g invoice extraction,
                    //first time run we start it for the user
                    Console('ready lets start the recipe', filterRecipe[0], 'log');
                    recipe_to_start_id = filterRecipe[0].recipe_id;
                  } else if (starter_recipe?.[0].recipe_id) {
                    // custom dynamic workato recipe to start and create g drive folders
                    recipe_to_start_id = starter_recipe?.[0].recipe_id;
                  } else {
                    recipe_to_start_id = filterRecipe[0].recipe_id;
                  }

                  Console('recipe_to_start_id', recipe_to_start_id, 'log');

                  const StartRecipe = async () => {
                    const payload = { url: `/api/managed_users/${workato_id}/recipes/${recipe_to_start_id}/start` };
                    Console('doing  wooo start recipe ', '', 'log');
                    await fetch(`/api/platform/proxy`, {
                      method: 'PUT',
                      headers: {
                        'Content-type': 'application/json',
                        'x-user-email': 'integrations@arcanum.ai',
                        'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
                      },
                      body: JSON.stringify(payload),
                    })
                      .then((Response) => Response.json())
                      .then((data) => {
                        Console('data back fromn woo starting recipe', data, 'log');
                        if (data.status === 'success' || data.success === true) {
                          Console('recipe start success', '', 'log');

                          let payload;

                          if (is_basic) {
                            // Basic upload
                            payload = {
                              status: 'complete',
                            };
                            fetchNow(`/api/platform/workatoRecipeStatus/${recipe_to_start_id}/`, 'PUT', payload, false);
                          } else if (filterRecipe[0]?.status === 'ready') {
                            // Our main recipe flow
                            Console('recipe is currently ready will set to complete', '', 'log');
                            payload = {
                              status: 'complete',
                            };
                            fetchNow(`/api/platform/workatoRecipeStatus/${recipe_to_start_id}/`, 'PUT', payload, false);
                            window.location.reload(false);
                          } else if (google_starter_combinations.includes(combination_id)) {
                            // anything else like the G drive setup recipe
                            payload = {
                              status: 'started',
                            };
                            fetchNow(`/api/platform/workatoRecipeStatus/${recipe_to_start_id}/`, 'PUT', payload, false);
                          } else {
                            // this is for all non google starter recipes
                            // just started the recipe and mark as complete
                            Console('xero recipe started and now complete', '', 'log');
                            payload = {
                              status: 'complete',
                            };
                            fetchNow(`/api/platform/workatoRecipeStatus/${recipe_to_start_id}/`, 'PUT', payload, false);
                            window.location.reload(false);
                          }
                        } else {
                          Console('recipe not started', '', 'log');
                        }

                        if (
                          !is_basic &&
                          starter_recipe &&
                          starter_recipe?.[0]?.status !== 'started' &&
                          starter_recipe?.[0]?.status !== 'complete' &&
                          needs_starter
                        ) {
                          Console('needs_starter', needs_starter, 'log');
                          Console('about to do a webhook call - most likey Gdrive recipe setup', '', 'log');
                          Console('webhook_url', starter_recipe?.[0].workato_webhook, 'log');
                          const payload = {
                            customer_id: workatoId,
                            email: email,
                            instance: envInstanceName,
                            recipe_id: actual_recipe_id,
                            combination_id: combination_id,
                          };

                          fetch(starter_recipe?.[0].workato_webhook, {
                            method: 'POST',
                            headers: {
                              'Content-type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                          })
                            .then((Response) => Response.json())
                            .then((data) => {
                              Console('woo resp: ', data, 'log');
                              if (data?.status === 'ok') {
                                window.location.reload(false);
                              }
                            })
                            .catch(console.error);
                        }
                      })
                      .catch(console.error);
                  };

                  if (
                    workato_id &&
                    recipe_to_start_id !== null &&
                    recipe_to_start_id !== 'undefined' &&
                    !finished_fetching_recipe
                  ) {
                    if (!WFSettings.requiresConfigBeforeStart.includes(combination_id)) {
                      Console('yes workato_id start the recipe', workato_id, 'log');
                      StartRecipe();
                    } else {
                      // we simply mark it that it was started and now complete
                      //so our setup continues as expected
                      const payload = {
                        status: 'complete',
                      };
                      fetchNow(`/api/platform/workatoRecipeStatus/${recipe_to_start_id}/`, 'PUT', payload, false);
                      window.location.reload(false);
                    }
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
      Console('clear the interval ourcons_connected', ourcons_connected);
      Console('clear the interval finished_fetching_recipe', finished_fetching_recipe);
      if (ourcons_connected && finished_fetching_recipe) {
        Console('clear the interval');
        clearInterval(intervalId);
      }
    };
    const intervalId = setInterval(() => {
      do_looper();
    }, 10000);
    do_looper();

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return {
    cons_data,
    conns_connected,
    isCheckingConns,
    workato_recipe,
    allRecipesData,
    isGettingRecipe,
    isStarterRecipe,
  };
};
